// zhTranslations.js
// Static Chinese translations used on receipts.
// Keys must exactly match the English strings in your orders.

export const zhMap = {
  // --- System / fulfilment ---
  "Delivery": "外卖",
  "Pickup": "自取",

  // --- Starters / sides / snacks ---
  "Prawn Crackers": "虾片",
  "Mini Spring Rolls": "迷你春卷",
  "Mini Spring Roll": "迷你春卷",
  "Pancake Rolls": "大春卷",
  "Chicken Satay": "沙爹鸡串",
  "Sesame Prawn Toast": "芝麻虾多士",
  "Crispy Seaweed": "脆海苔",
  "Chips": "薯条",
  "Curry Chips": "咖喱薯条",
  "Chicken Balls": "鸡球",
  "King Prawn Balls": "大虾球",
  "Crispy Won Ton": "脆云吞",
  "Mixed Starters": "拼盘前菜",
  "Won Ton": "云吞",
  "Boiled Rice": "白饭",
  "Egg Fried Rice": "蛋炒饭",
  "Plain Chow Mein": "清炒炒面",
  "Plain Ho Fun": "清炒河粉",
  "Stir Fried Beansprouts": "清炒豆芽",
  "Stir Fried Mushrooms": "清炒蘑菇",
  "Stir Fried Vegetables": "清炒杂菜",

  // --- Soups ---
  "Hot & Sour": "酸辣汤",
  "Chicken & Sweetcorn": "鸡蓉粟米汤",
  "Chicken & Mushroom": "鸡蘑菇汤",
  "Chicken & Noodle": "鸡肉面汤",

  // --- Ribs flavours ---
  "Black Pepper": "黑椒",
  "Salt & Pepper": "椒盐",
  "Dry BBQ": "干烧烧烤味",
  "BBQ Sauce": "烧烤酱",
  "Sweet & Sour": "甜酸",
  "Honey Roasted": "蜜汁烤",

  // --- Salt & pepper range ---
  "Chicken Fillets": "鸡柳",
  "Chicken Wings": "鸡翅",
  "King Prawn": "大虾",
  "Fish Fillet": "鱼柳",

  // --- Dumplings ---
  "Vegetable Dumplings": "菜饺",
  "Chicken Dumplings": "鸡肉饺",
  "Prawn Dumplings": "虾饺",

  // --- Chop Suey / Foo Yung / mains ---
  "Chop Suey": "杂碎",
  "Foo Yung / Omelette": "芙蓉蛋 / 蛋饼",

  "Crispy Shredded Chilli Chicken": "香脆辣椒鸡丝",
  "Crispy Shredded Chilli Beef": "香脆辣椒牛丝",
  "Chicken in Orange Sauce": "陈皮鸡",
  "Chicken in Lemon Sauce": "柠檬鸡",

  // --- Protein / base options (fried rice, chow mein, etc.) ---
  "Vegetable": "蔬菜",
  "Mushroom": "蘑菇",
  "Chicken": "鸡肉",
  "Beef": "牛肉",
  "Shrimp": "虾仁",
  "Roast Duck": "烤鸭",
  "Plant-Based Chicken": "植物鸡肉",
  "Plant-based Chicken": "植物鸡肉",
  "Panda Special": "熊猫特餐",
  "Singaporean Special": "新加坡风味特餐",
  "House Special": "招牌特餐",

  // --- Rice noodle / fried rice / chow mein section (reuse same base names) ---
  // (All already covered: Vegetable, Mushroom, Chicken, Beef, Shrimp, King Prawn, Roast Duck,
  //  Plant-Based Chicken, Panda Special, Singaporean Special, House Special)

  // --- Classic Sauce Dishes (base protein names reused) ---
  "Mixed Veg": "杂菜",

  // --- Classic sauce variations ---
  "with Pineapple": "配菠萝",
  "with Mushrooms": "配蘑菇",
  "with Tomato": "配番茄",
  "with Cashew Nuts": "配腰果",
  "with Oyster Sauce": "配蚝油",
  "with Mixed Vegetables": "配杂菜",
  "with Ginger & Spring Onions": "配姜葱",
  "with Cashew Nuts in Yellow Bean Sauce": "配黄豆酱腰果",
  "with Green Peppers": "配青椒",
  "with Garlic Sauce": "配蒜蓉汁",

  "with Kung Pao Sauce": "宫保酱",
  "with Black Bean Sauce": "豆豉酱",
  "with Schezwan Sauce": "四川酱",
  "with Peking Sauce": "北京酱",
  "with Sweet & Sour Sauce": "甜酸酱",
  "with Curry Sauce": "咖喱酱",
  "with Hoi Sin Sauce": "海鲜酱",
  "with Thai Sweet Chilli Sauce": "泰式甜辣酱",

  // --- Sauces as standalone sides ---
  "Curry Sauce": "咖喱汁",
  "Black Bean Sauce": "豆豉酱",
  "Sweet & Sour Sauce": "甜酸汁",
  "Chilli Oil": "辣椒油",
  "Hoi Sin Sauce": "海鲜酱",
  "Satay Sauce": "沙爹酱",

  // --- Sides / small dishes ---
  "Soft Drinks": "软饮料",
  "Premium Soft Drinks": "高级软饮",
  "Water": "矿泉水",
  "Fizzy Drinks": "汽水",

  // --- Branded drink variations ---
  "Fruit Shoot Orange": "Fruit Shoot 橙味",
  "Fruit Shoot Apple & Blackcurrant": "Fruit Shoot 苹果黑加仑",
  "Tango Strawberry Smash": "Tango 草莓味汽水",
  "Tango Cherry": "Tango 樱桃味汽水",
  "Tango Orange": "Tango 橙味汽水",
  "Tango Apple": "Tango 苹果味汽水",
  "Tango Mango": "Tango 芒果味汽水",
  "Tango Dark Berry": "Tango 浆果味汽水",
  "Rubicon Passion Fruit": "Rubicon 百香果",
  "Rubicon Guava": "Rubicon 番石榴",
  "Rubicon Mango": "Rubicon 芒果",
  "Barr Limeade": "Barr 青柠汽水",
  "Barr Cherryade": "Barr 樱桃汽水",
  "Barr Cola": "Barr 可乐",


  // --- Common Modifiers / Sizes ---
  "Regular": "常规",
  "Large": "大份",
  "Small": "小份",
  "Medium Spice": "中辣",
  "Mild Spice": "微辣",
  "Hot Spice": "特辣",
  "No Spice": "免辣",
  "Hot": "辣",
  "1/4 Naga": "1/4 娜迦辣",
  "1/2 Naga": "1/2 娜迦辣",
  "Full Naga": "全娜迦辣",

  // --- Modifiers / Proteins (often used as Variation) ---
  "Chicken": "鸡肉",
  "Beef": "牛肉",
  "Shrimp": "虾仁",
  "King Prawn": "大虾",
  "Roast Duck": "烤鸭",
  "Vegetable": "蔬菜",
  "Mushroom": "蘑菇",
  "Fish Fillet": "鱼柳",
  "Plant-Based Chicken": "植物鸡肉",
  "Plant-based Chicken": "植物鸡肉",
  "Mixed Veg": "杂菜",


  // --- Fried Rice ---
  "Chicken Fried Rice": "鸡肉炒饭",
  "Beef Fried Rice": "牛肉炒饭",
  "Shrimp Fried Rice": "虾仁炒饭",
  "King Prawn Fried Rice": "大虾炒饭",
  "Roast Duck Fried Rice": "烤鸭炒饭",
  "Vegetable Fried Rice": "杂菜炒饭",
  "Mushroom Fried Rice": "蘑菇炒饭",
  "House Special Fried Rice": "招牌炒饭",
  "Singaporean Special Fried Rice": "新加坡炒饭",
  "Plant-Based Chicken Fried Rice": "植物鸡肉炒饭",
  "Panda Special Fried Rice": "熊猫特餐炒饭",
  "Young Chow Fried Rice": "扬州炒饭",

  // --- Chow Mein ---
  "Chicken Chow Mein": "鸡肉炒面",
  "Beef Chow Mein": "牛肉炒面",
  "Shrimp Chow Mein": "虾仁炒面",
  "King Prawn Chow Mein": "大虾炒面",
  "Roast Duck Chow Mein": "烤鸭炒面",
  "Vegetable Chow Mein": "杂菜炒面",
  "Mushroom Chow Mein": "蘑菇炒面",
  "House Special Chow Mein": "招牌炒面",
  "Singaporean Special Chow Mein": "新加坡炒面",
  "Plant-Based Chicken Chow Mein": "植物鸡肉炒面",
  "Panda Special Chow Mein": "熊猫特餐炒面",

  // --- Rice Noodles ---
  "Chicken Rice Noodles": "鸡肉米粉",
  "Beef Rice Noodles": "牛肉米粉",
  "Shrimp Rice Noodles": "虾仁米粉",
  "King Prawn Rice Noodles": "大虾米粉",
  "Roast Duck Rice Noodles": "烤鸭米粉",
  "Vegetable Rice Noodles": "杂菜米粉",
  "Mushroom Rice Noodles": "蘑菇米粉",
  "House Special Rice Noodles": "招牌米粉",
  "Singaporean Special Rice Noodles": "新加坡米粉",
  "Plant-Based Chicken Rice Noodles": "植物鸡肉米粉",
  "Panda Special Rice Noodles": "熊猫特餐米粉"
};
